export default __webpack_public_path__ + "locales/it/ChangeUserStatusDialog.json?hash=9ddb5155ead36382f464a418658790eb";